export default "__VITE_ASSET__CkumzrRV__"